<div class="presentation-settings-container">
  <a class="action-item" matRipple (click)="openAudioSettingsMenu()">
    Audience Settings
    <svg width="24" height="24" style="float: right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17L15 12L10 7V17Z" fill="#333333" />
    </svg>
  </a>
  <a class="action-item" matRipple (click)="openManagePresentersMenu()">
    Manage Presenters
    <svg width="24" height="24" style="float: right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17L15 12L10 7V17Z" fill="#333333" />
    </svg>
  </a>
</div>
